import React from 'react';
import { useSelector } from 'react-redux';

const LoadingAnimation = ({ imageStyling, styling }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  return (
    <div className={`flex flex-col  items-center justify-center space-x-2 ${styling} py-10`}>
      <img src="/assets/glasshour.gif" alt="" className={`    ${imageStyling}`} />
      <p className="text-center text-2xl font-semibold">{!isActive ? 'Content loading...' : 'جاري التحميل...'}</p>
    </div>
    // <div className="flex h-screen items-center justify-center space-x-2">
    //   <img
    //     src="/assets/sandClock.gif"

    //     alt=""
    //     className="animate-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    //   />
    //   <p className="text-center text-2xl font-semibold">{!isActive ? 'Content loading...' : 'جاري التحميل...'}</p>
    // </div>
  );
};

export default LoadingAnimation;
